module.exports = __webpack_public_path__ + "media/assets/images/plan02-00bb4480ac9413230d0c1eeee3775f0b.png";